export { bootstrapTextAnalytics } from './bootstrap'
